import { ClientDataService } from './../client-data.service';
import { DatePipe } from '@angular/common';
import { Injectable } from '@angular/core';
import pdfMake from './../../../assets/datatable/js/pdfmake.min.js';  //'pdfmake/build/pdfmake';
import pdfFonts from './../../../assets/datatable/js/vfs_fonts.js'; //'pdfmake/build/vfs_fonts';
pdfMake.vfs = pdfFonts.pdfMake.vfs;
import * as logoFile from './../../../assets/logo.js';
import { NseService } from '../nse.service'
@Injectable({
  providedIn: 'root'
})
export class PdfService {

  myDate = new Date();
  disclaimer = 'This statement is based on the information made available to us by the Asset Management Companies (AMC). To that extent, there may be a delay in updating the latest values in this statement in case of delay in receipt of data from the AMCs. Hence, the statement from the respective AMC should reflect the exact information for the respective folio. Any discrepancy in the above statement should be reported to us. The tax calculations are made based on our interpretation of the Income tax Act. Please contact your Accountant/Tax consultant for the exact calculations. Maturity Date, where displayed is based on available information.';
  todaysDate = this.datePipe.transform(this.myDate, 'dd/MM/yyyy');

  constructor(private datePipe: DatePipe, private cds: ClientDataService, private NSE: NseService) { }

  //********* added by Mohit on 30-09-2020 for dynamic PDF generate  *********/
  // generatePDF(PdfName, Content) {

  //   debugger

  //   let TopImage = logoFile.TopImageJM;
  //   let BottomImage = logoFile.BottomImageJM;

  //   var dd = {
  //     //to view pdf in full view - eg: 'A0','A3','A4','LEGAL'
  //     pageSize: 'A4',
  //     // by default we use portrait, you can change it to landscape if you wish
  //     pageOrientation: 'landscape',
  //     // [left, top, right, bottom] or [horizontal, vertical] or just a number for equal margins
  //     pageMargins: [20, 130, 20, 20],

  //     header: function (currentPage, pageCount, pageSize) {
  //       let PdfHeaderImg = '';
  //       ////
  //         if (currentPage == 1) {
  //           PdfHeaderImg = TopImage;
  //         }
  //         else {
  //           PdfHeaderImg = BottomImage;
  //         }
  //         return [
  //           {
  //             image: PdfHeaderImg,
  //             //image: pdfLogo,
  //             absolutePosition: {  // image positioning from margin
  //               x: 20, y: 20
  //             },
  //             width: 800, height: 95, //image size increase/decrease
  //             margin: [0, 50, 0, 10],// [left, top, right, bottom]
  //           },
  //         ]

  //     },

  //     content: [
  //       Content
  //     ],

  //     footer: (currentPage, totalPage) => {
  //       return {
  //         text: `Page ${currentPage.toString()} of ${totalPage.toString()}`,
  //         alignment: 'right',
  //         fontSize: 10,
  //         margin: [20, 0]
  //       }
  //     },

  //     styles: {
  //       header: {
  //         fontSize: 16,
  //         bold: true,
  //         margin: [0, 30, 0, 10],
  //         color: '#282828'
  //       },
  //       subheader: {
  //         fontSize: 13.5,
  //         bold: true,
  //         margin: [0, 10, 0, 5],
  //         color: '#282828'
  //       },
  //       ReportDate: {
  //         alignment: 'right',
  //         color: '#282828'
  //       },
  //       tableExample: {
  //         //fontSize: 10,
  //         margin: [0, 5, 0, 15],
  //       },
  //       tableHeader: {
  //         fontSize: 10,
  //         bold: true
  //       },
  //     },
  //     defaultStyle: {
  //       //font : 'SegoeUI',
  //       fontSize: 9,
  //       color: '#434343'
  //     }
  //   }
  //   //pdfMake.fonts = {
  //   //  SegoeUI: {
  //   //    normal: 'https://cdn.jsdelivr.net/npm/open-sans-all@0.1.3/fonts/open-sans-regular.ttf',
  //   //    bold: 'https://cdn.jsdelivr.net/npm/open-sans-all@0.1.3/fonts/open-sans-600.ttf',
  //   //    italics: 'https://cdn.jsdelivr.net/npm/open-sans-all@0.1.3/fonts/open-sans-italic.ttf',
  //   //    bolditalics: 'https://cdn.jsdelivr.net/npm/open-sans-all@0.1.3/fonts/open-sans-600italic.ttf'
  //   //  }
  //   //}
  //   pdfMake.createPdf(dd).download(`${PdfName}_${this.todaysDate}.pdf`);
  //   //pdfMake.createPdf(dd).open();
  // }
  generatePDF(PdfName, Content, pdfLogo = "") {

    debugger

    let TopImage = logoFile.TopImageJM;
    let BottomImage = logoFile.BottomImageJM;

    var dd = {
      //to view pdf in full view - eg: 'A0','A3','A4','LEGAL'
      pageSize: 'A4',
      // by default we use portrait, you can change it to landscape if you wish
      pageOrientation: 'landscape',
      // [left, top, right, bottom] or [horizontal, vertical] or just a number for equal margins
      pageMargins: [20, 130, 20, 20],

      header: function (currentPage, pageCount, pageSize) {
        let PdfHeaderImg = '';
        ////
        if (currentPage == 1) {
          PdfHeaderImg = (pdfLogo != "") ? pdfLogo : TopImage;

        }
        else {
          PdfHeaderImg = (pdfLogo != "") ? pdfLogo : BottomImage;
        }
        return [
          {
            image: PdfHeaderImg,
            //image: pdfLogo,
            absolutePosition: {  // image positioning from margin
              x: 20, y: 20
            },
            width: 800, height: 95, //image size increase/decrease
            margin: [0, 50, 0, 10],// [left, top, right, bottom]
          },
        ]

      },

      content: [
        Content
      ],

      footer: (currentPage, totalPage) => {
        return {
          text: `Page ${currentPage.toString()} of ${totalPage.toString()}`,
          alignment: 'right',
          fontSize: 10,
          margin: [20, 0]
        }
      },

      styles: {
        header: {
          fontSize: 16,
          bold: true,
          margin: [0, 30, 0, 10],
          color: '#282828'
        },
        subheader: {
          fontSize: 13.5,
          bold: true,
          margin: [0, 10, 0, 5],
          color: '#282828'
        },
        ReportDate: {
          alignment: 'right',
          color: '#282828'
        },
        tableExample: {
          //fontSize: 10,
          margin: [0, 5, 0, 15],
        },
        tableHeader: {
          fontSize: 10,
          bold: true
        },
      },
      defaultStyle: {
        //font : 'SegoeUI',
        fontSize: 9,
        color: '#434343'
      }
    }
    //pdfMake.fonts = {
    //  SegoeUI: {
    //    normal: 'https://cdn.jsdelivr.net/npm/open-sans-all@0.1.3/fonts/open-sans-regular.ttf',
    //    bold: 'https://cdn.jsdelivr.net/npm/open-sans-all@0.1.3/fonts/open-sans-600.ttf',
    //    italics: 'https://cdn.jsdelivr.net/npm/open-sans-all@0.1.3/fonts/open-sans-italic.ttf',
    //    bolditalics: 'https://cdn.jsdelivr.net/npm/open-sans-all@0.1.3/fonts/open-sans-600italic.ttf'
    //  }
    //}
    pdfMake.createPdf(dd).download(`${PdfName}_${this.todaysDate}.pdf`);
    //pdfMake.createPdf(dd).open();
  }
  //********* Portrait, form style PDF (label / value sections) - used by the Franchisee Application Form *********/
  //HeaderFromPage - first page that should carry the running header (pages before it are merged documents)
  //SaveAsName - file name to save under (the applicant's PAN); falls back to the title and today's date
  generateFormPDF(PdfName, Content, HeaderFromPage = 1, SaveAsName = '') {

    let GeneratedOn = this.datePipe.transform(new Date(), 'dd/MM/yyyy hh:mm a');

    var dd = {
      pageSize: 'A4',
      pageOrientation: 'portrait',
      // [left, top, right, bottom]
      pageMargins: [25, 45, 25, 35],

      header: function (currentPage, pageCount, pageSize) {
        if (currentPage < HeaderFromPage) return { text: '' };
        return { text: PdfName, fontSize: 9.5, color: '#767676', margin: [25, 22, 25, 0] }
      },

      footer: (currentPage, totalPage) => {
        return {
          columns: [
            { text: 'Generated on : ' + GeneratedOn, fontSize: 7.5, color: '#767676', margin: [25, 0, 0, 0] },
            { text: `Page ${currentPage.toString()} of ${totalPage.toString()}`, alignment: 'right', fontSize: 7.5, color: '#767676', margin: [0, 0, 25, 0] }
          ]
        }
      },

      content: [
        Content
      ],

      styles: {
        header: {
          fontSize: 15,
          bold: true,
          margin: [0, 0, 0, 2],
          color: '#282828'
        },
        subheader: {
          fontSize: 9,
          margin: [0, 0, 0, 10],
          color: '#767676'
        },
        sectionHeading: {
          fontSize: 10.5,
          bold: true,
          margin: [0, 12, 0, 5],
          color: '#EE7623'
        },
        groupHeading: {
          fontSize: 9,
          bold: true,
          margin: [0, 6, 0, 3],
          color: '#282828'
        },
        emptyNote: {
          fontSize: 8.5,
          italics: true,
          margin: [0, 2, 0, 4],
          color: '#767676'
        },
        fieldLabel: {
          fontSize: 8,
          color: '#767676'
        },
        fieldValue: {
          fontSize: 8.5,
          bold: true,
          color: '#282828'
        },
        tableHeader: {
          fontSize: 8.5,
          bold: true,
          color: '#282828'
        }
      },
      defaultStyle: {
        fontSize: 8.5,
        color: '#434343'
      }
    }

    //a name was supplied (the PAN) - strip anything a file name cannot contain
    let SaveAs = (SaveAsName != null && ('' + SaveAsName).trim() != '')
      ? ('' + SaveAsName).trim().replace(/[\\/:*?"<>|]/g, '')
      : `${PdfName}_${this.todaysDate}`;

    pdfMake.createPdf(dd).download(`${SaveAs}.pdf`);
  }

  getBase64FromPDF(PdfName, Content, ClientBasicInfoId) {
    //#region
    let BaseString = '';
    let CompanyLogo = '';
    let TopImage = '';
    let BottomImage = '';

    //#region - Dynamic Logo Logic for Corporate and IFA
    let Flag = sessionStorage.getItem("Vbhs@#%LMKIo="); //Flag > C = Corporate | I = IFA
    if (Flag != null && Flag != "" && Flag != undefined) {
      if (Flag === "C") {

        switch (this.cds.GetCompanyName()) {
          // case "AU":
          //   TopImage = logoFile.AUTopImage;
          //   BottomImage = logoFile.AUBottomImage;
          //   break;

          // default:
          //   break;
        }
      }
      else {

      }
    }
    //#endregion

    var dd = {
      //to view pdf in full view - eg: 'A0','A3','A4','LEGAL'
      pageSize: 'TABLOID',
      // by default we use portrait, you can change it to landscape if you wish
      pageOrientation: 'landscape',
      // [left, top, right, bottom] or [horizontal, vertical] or just a number for equal margins
      pageMargins: [20, 130, 20, 20],

      // header: function (currentPage, pageCount, pageSize) {
      //   let PdfHeaderImg = '';
      //   ////
      //   if (Flag === "C") { //corporate
      //     if (currentPage == 1) {
      //       PdfHeaderImg = TopImage;
      //     }
      //     else {
      //       PdfHeaderImg = BottomImage;
      //     }
      //     return [
      //       {
      //         image: PdfHeaderImg,
      //         //image: pdfLogo,
      //         absolutePosition: {  // image positioning from margin
      //           x: 20, y: 20
      //         },
      //         width: 800, height: 95, //image size increase/decrease
      //         margin: [0, 50, 0, 10],// [left, top, right, bottom]
      //       },
      //     ]
      //   }
      //   else { //IFA
      //     if (currentPage == 1) {
      //       PdfHeaderImg = TopImage;
      //     }
      //     else {
      //       PdfHeaderImg = BottomImage;
      //     }
      //     return [
      //       {
      //         image: PdfHeaderImg,
      //         //image: pdfLogo,
      //         absolutePosition: {  // image positioning from margin
      //           x: 20, y: 20
      //         },
      //         width: 800, height: 95, //image size increase/decrease
      //         margin: [0, 50, 0, 10],// [left, top, right, bottom]
      //       },
      //       {
      //         image: CompanyLogo,
      //         //image: pdfLogo,
      //         absolutePosition: {  // image positioning from margin
      //           x: 720, y: 20
      //         },
      //         width: 100, height: 45, //image size increase/decrease
      //         //margin: [0, 50, 0, 10],// [left, top, right, bottom]
      //       }
      //     ]
      //   }
      // },

      content: [
        Content
      ],

      // footer: (currentPage, totalPage) => {
      //   return {
      //     text: `Page ${currentPage.toString()} of ${totalPage.toString()}`,
      //     alignment: 'right',
      //     fontSize: 10,
      //     margin: [20, 0]
      //   }
      // },

      styles: {
        header: {
          fontSize: 16,
          bold: true,
          margin: [0, 30, 0, 10],
          color: '#282828'
        },
        subheader: {
          fontSize: 13.5,
          bold: true,
          margin: [0, 10, 0, 5],
          color: '#282828'
        },
        ReportDate: {
          alignment: 'right',
          color: '#282828'
        },
        tableExample: {
          //fontSize: 10,
          margin: [0, 5, 0, 15],
        },
        tableHeader: {
          fontSize: 10,
          bold: true
        },
      },
      defaultStyle: {
        //font : 'SegoeUI',
        fontSize: 9,
        color: '#434343'
      }
    }
    //#endregion

    BaseString = pdfMake.createPdf(dd).getBase64((data) => {
      //return data;
      // this.NSE.SendingHoldingReportTOClient(data, ClientBasicInfoId).subscribe((data) => {

      // });
      let pdfdata = "data:application/pdf;base64, " + data
      //console.log(btoa(pdf))
      let DATA = pdfdata;
      const link = document.createElement("a")
      link.href = DATA;
      link.download = PdfName + ".pdf"
      link.click()
      link.remove()
    });
  }

  // Func to return generated table
  table(data, columns, witdhsDef, showHeaders, headers, requiredFooter = true) {
    debugger
    let TableLength = data.length;
    return {
      style: 'tableExample',
      table: {
        headerRows: 1,
        dontBreakRows: true,
        widths: witdhsDef,
        style: 'tableHeader',
        body: this.buildTableBody(data, columns, showHeaders, headers)
      },
      // Table Styles
      layout: {
        hLineWidth: function (i, node) { return (i === 1) ? 1 : 0; },
        vLineWidth: function (i, node) { return 0; },
        hLineColor: function (i, node) { return (i === 1) ? '#fff' : '#fff'; },
        vLineColor: function (i, node) { return '#fff' },
        // paddingBottom: function (i, node) {
        //   return 5;
        // },
        // paddingTop: function (i, node) {
        //   return 5;
        // },
        paddingLeft: function (i, node) { return 21; }, // Adjust padding as needed
        paddingRight: function (i, node) { return 22; },
        paddingTop: function (i, node) { return 10; },
        paddingBottom: function (i, node) { return 10; },

        fillColor: function (rowIndex, node, columnIndex) {
          ////////
          switch (rowIndex) {
            case 0:
              return '#e5e5e5';
              break;
            default:
              if (rowIndex == TableLength) {
                if (requiredFooter) {
                  let rr: any = data[TableLength];
                  return '#e5e5e5';
                } else {
                  return (rowIndex % 2 === 0) ? '#f7f7f7' : '#fff';
                }
              } else {
                return (rowIndex % 2 === 0) ? '#f7f7f7' : '#fff';
              }
              break;
          }
        },
      },
    };
  }
  // Table body builder
  buildTableBody(data, columns, showHeaders, headers) {
    var body = [];
    // Inserting headers
    if (showHeaders) {
      body.push(headers);
    }
    // Inserting items from external data array
    data.forEach(function (row) {
      var dataRow = [];
      var i = 0;
      columns.forEach(function (column) {
        dataRow.push({ text: row[column], alignment: headers[i].alignmentChild });
        i++;
      });
      body.push(dataRow);
    });
    return body;
  }
  //--------------------------------------------------------------------------------------------------

  generatePdf(pdfName, pdfData, pdfLogo, ClientName, ClientPAN, SubbrokerName, pdfHeader_Width, UserType, ClientRMName, ClientRMContact) {
    let TodaysDate = this.datePipe.transform(this.myDate, 'dd/MM/yyyy');
    const documentDefinition = this.getDocumentDefinition(pdfName, pdfData, pdfLogo, ClientName, ClientPAN, SubbrokerName, pdfHeader_Width, UserType, ClientRMName, ClientRMContact);
    pdfMake.createPdf(documentDefinition).download(`${pdfName}_${TodaysDate}.pdf`);
  }

  getDocumentDefinition(pdfName, pdfData, pdfLogo, ClientName, ClientPAN, SubbrokerName, pdfHeader_Width, UserType, ClientRMName, ClientRMContact) {
    let TodaysDate = this.datePipe.transform(this.myDate, 'dd/MM/yyyy');
    var DynamicClientInfo: any;
    if (ClientName == '') {
      DynamicClientInfo = { text: 'Report Generated Date : ' + TodaysDate, fontSize: 10, style: 'ReportDate' }
    }
    else {
      let Text: string = '';
      Text = parseInt(UserType) == 1 ? 'Relationship Manager         :  ' : 'Distributor Name          :  ';
      console.log('PDF Service yser type ' + UserType);
      if (parseInt(UserType) == 3) {
        DynamicClientInfo = {
          columns: [
            {
              text:
                'Investor Name           :  ' + ClientName + '\n' +
                'PAN No.                      :  ' + ClientPAN + '\n' +
                'RM Name                    : ' + ClientRMName + '\n' +
                'RM Contact                : ' + ClientRMContact + '\n\n', fontSize: 10
            },
            { text: 'Report Generated Date : ' + TodaysDate, fontSize: 10, style: 'ReportDate' },
          ],
        }
      } else {
        DynamicClientInfo = {
          columns: [
            {
              text:
                'Investor Name           :  ' + ClientName + '\n' +
                'PAN No.                      :  ' + ClientPAN + '\n' +
                'RM Name                    : ' + ClientRMName + '\n' +
                'RM Contact                : ' + ClientRMContact + '\n\n', fontSize: 10
            },
            { text: 'Report Generated Date : ' + TodaysDate, fontSize: 10, style: 'ReportDate' },
          ],
        }
      }
    }

    //#region - Dynamic Logo Logic for Corporate and IFA
    let CompanyLogo = '';
    let TopImage = '';
    let BottomImage = '';
    let Flag = sessionStorage.getItem("Vbhs@#%LMKIo="); //Flag > C = Corporate | I = IFA
    if (Flag != null && Flag != "" && Flag != undefined) {
      if (Flag === "C") {

        switch (this.cds.GetCompanyName()) {
          // case "AU":
          //   TopImage = logoFile.AUTopImage;
          //   BottomImage = logoFile.AUBottomImage;
          //   break;

          // default:
          //   break;
        }
      }
      else {

      }
    }
    //#endregion


    return {
      //to view pdf in full view - eg: 'A0','A3','A4','LEGAL'
      pageSize: 'A4',
      // by default we use portrait, you can change it to landscape if you wish
      pageOrientation: 'landscape',
      // [left, top, right, bottom] or [horizontal, vertical] or just a number for equal margins
      pageMargins: [20, 130, 20, 20],

      // customize: function (doc) {
      //   doc.styles.tableHeader.fontSize = 14;
      //   doc.content[1].table.widths = Array(doc.content[1].table.body[0].length + 1).join('*').split('');
      // },

      // header: function (currentPage, pageCount, pageSize) {
      //   return [
      //     {
      //       // image: logoFile.TopImage,
      //       // //image: pdfLogo,
      //       // absolutePosition: {  // image positioning from margin
      //       //   x: 20, y: 20
      //       // },
      //       // width: 800, height: 95, //image size increase/decrease
      //       // margin: [0, 50, 0, 15],// [left, top, right, bottom]
      //     }
      //   ]
      // },

      header: function (currentPage, pageCount, pageSize) {
        let PdfHeaderImg = '';
        ////
        if (Flag === "C") { //corporate
          if (currentPage == 1) {
            PdfHeaderImg = pdfLogo;
          }
          else {
            PdfHeaderImg = pdfLogo;
          }
          return [
            {
              image: PdfHeaderImg,
              //image: pdfLogo,
              absolutePosition: {  // image positioning from margin
                x: 20, y: 20
              },
              width: 800, height: 95, //image size increase/decrease
              margin: [0, 50, 0, 10], //[left, top, right, bottom]
            },
          ]
        }
        else { //IFA
          if (currentPage == 1) {
            PdfHeaderImg = pdfLogo;
          }
          else {
            PdfHeaderImg = pdfLogo;
          }
          return [
            {
              image: PdfHeaderImg,
              //image: pdfLogo,
              absolutePosition: {  // image positioning from margin
                x: 20, y: 20
              },
              width: 800, height: 95, //image size increase/decrease
              margin: [0, 50, 0, 10],// [left, top, right, bottom]
            }
          ]
        }
      },

      footer: (currentPage, totalPage) => {
        return {
          text: `Page ${currentPage.toString()} of ${totalPage.toString()}`,
          alignment: 'right',
          fontSize: 10,
          margin: [20, 0]
        }
      },

      content: [
        { text: pdfName, style: 'header', alignment: 'center' },
        DynamicClientInfo,
        //table 1 - start
        { text: 'Summary', style: 'subheader', },   //margin: [0, 20, 0, 8]
        {
          style: 'tableExample',
          table: {
            headerRows: 1,
            dontBreakRows: true,
            //widths: pdfHeader_Width,
            style: 'tableHeader',
            body: pdfData,
          },

          // Table Styles
          layout: {
            hLineWidth: function (i, node) { return (i === 1) ? 1 : 0; },
            vLineWidth: function (i, node) { return 0; },
            hLineColor: function (i, node) { return (i === 1) ? '#4CAF50' : '#fff'; },
            vLineColor: function (i, node) { return '#fff' },
            paddingBottom: function (i, node) {
              return 5;
            },
            paddingTop: function (i, node) {
              return 5;
            },
            fillColor: function (rowIndex, node, columnIndex) {
              switch (rowIndex) {
                case 0:
                  return '#faf8f8';
                  break;
                default:
                  return (rowIndex % 2 === 0) ? '#f7f7f7' : '#fff';
                  break;
              }
            },
          },
        },
        //table 1 - end
        { text: 'Disclaimer : ', style: 'subheader', fontSize: 12 },
        { text: 'This Statement/Report has been prepared based on the information available with Incred Markets and/or the data provided by the Registrar and Transfer Agents (RTAs), AMCs, Issuers, Companies, any other external agencies, etc. which IIFL believes to be reliable.The incorrect or insufficient data received from the above sources may lead to incomplete/inaccurate Statement/Report.  The data in this Statement/Report, including but not limited to NAVs, is subject to revision/rectification by IIFL/ RTA / AMC/Issuers/Companies, etc. at any point of time. IIFL reserves the right to update the Statement/Report at such frequency as it may deem fit and also reserves the right to amend and/or rectify the discrepancies, if any, in this Statement/Report at any time without assigning any reason whatsoever. As a result of such revision/rectification, the data made available in this Statement/Report prior to such rectification/revision may undergo change. The above Statement/Report is not available on a real time basis. IIFL or any of its directors, employees or agents take no responsibility for any inaccuracy or incompleteness in this Statement/Report. For taking any investment decision including, but not limited to, redemptions and switches, Independent Financial Distributor (MA)/investor is requested to always refer/rely on the Statement of Account provided by AMC/Registrars. Note: 1. For Mutual Fund (MF), this statement summarises total holdings at scheme & folio level for your client, based on transactional data available from AMCs/RTAs as on report generation date. 2. Latest available NAV is taken for the purpose of showing as on date valuation. For NAV=0 or for a blank NAV, the last reported NAV will be considered. 3. Actual Cost of balance units in a scheme for a folio= (Number of balance units) x (Purchase NAV). There could be a minor difference in the Cost to the extent of Entry load on transactions prior to 1st August 2009 and having balance units as on report date. 4. The actual profit/loss values in this statement contains Dividend, hence it may not exactly match with the values in Capital Gain/Loss statement.', fontSize: 10 }
      ],

      styles: {
        header: {
          fontSize: 14,
          bold: true,
          margin: [0, 0, 0, 10]
        },
        subheader: {
          fontSize: 11,
          bold: true,
          margin: [0, 10, 0, 5]
        },
        ReportDate: {
          alignment: 'right'
        },
        tableExample: {
          fontSize: 10,
          margin: [0, 5, 0, 15],
        },
        tableHeader: {
          fontSize: 10,
          bold: true,
        },
      },
      defaultStyle: {
        // alignment: 'justify'
      }
    }
  }

  ReturnBase64FromPDF(PdfName, Content, ClientBasicInfoId) {
    //#region
    debugger
    let BaseString = '';
    let CompanyLogo = '';
    let TopImage = '';
    let BottomImage = '';

    //#region - Dynamic Logo Logic for Corporate and IFA
    let Flag = sessionStorage.getItem("Vbhs@#%LMKIo="); //Flag > C = Corporate | I = IFA
    if (Flag != null && Flag != "" && Flag != undefined) {
      if (Flag === "C") {

        switch (this.cds.GetCompanyName()) {

        }
      }
      else {

      }
    }
    //#endregion

    var dd = {
      //to view pdf in full view - eg: 'A0','A3','A4','LEGAL'
      pageSize: 'TABLOID',
      // by default we use portrait, you can change it to landscape if you wish
      pageOrientation: 'landscape',
      // [left, top, right, bottom] or [horizontal, vertical] or just a number for equal margins
      pageMargins: [20, 130, 20, 20],


      content: [
        Content
      ],


      styles: {
        header: {
          fontSize: 16,
          bold: true,
          margin: [0, 30, 0, 10],
          color: '#282828'
        },
        subheader: {
          fontSize: 13.5,
          bold: true,
          margin: [0, 10, 0, 5],
          color: '#282828'
        },
        ReportDate: {
          alignment: 'right',
          color: '#282828'
        },
        tableExample: {
          //fontSize: 10,
          margin: [0, 5, 0, 15],
        },
        tableHeader: {
          fontSize: 10,
          bold: true
        },
      },
      defaultStyle: {
        //font : 'SegoeUI',
        fontSize: 9,
        color: '#434343'
      }
    }
    //#endregion

    BaseString = pdfMake.createPdf(dd).getBase64((data) => {
      //return data;
      // this.NSE.SendingHoldingReportTOClient(data, ClientBasicInfoId).subscribe((data) => {

      // });
      let pdfdata = "data:application/pdf;base64, " + data
      //console.log(btoa(pdf))
      let DATA = pdfdata;
      return DATA;
      // const link = document.createElement("a")
      // link.href = DATA;
      // link.download = PdfName + ".pdf"
      // link.click()
      // link.remove()
    });
  }

}
